import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { Button, Card } from "antd";
import SubscriptionModal from "../../../../components/subscription-modal";

const PaymentCancel = () => {
  const [subscriptionPreview, setsubscriptionPreview] = useState(false);
  const history = useHistory();
  return (
    <div className="payment-response-wrapper">
      <Card>
        <h1>Payment Canceled</h1>
        <p>
          Your payment process was canceled. If this was unintentional, please
          retry the payment process.
        </p>
        <div className="action-wrapper">
          <Button
            type="primary"
            onClick={() => setsubscriptionPreview(true)}
            className="action-btn"
          >
            Retry
          </Button>
        </div>
      </Card>
      <SubscriptionModal
        preview={subscriptionPreview}
        closeHandler={() => setsubscriptionPreview(false)}
      />
    </div>
  );
};
export default PaymentCancel;
